import React from 'react';

// Logo Option 1: Shield + Text (Classic Legal)
export const Logo1 = ({ className = "" }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <svg width="40" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shield Shape */}
      <path 
        d="M20 2L2 10V22C2 33 8 42 20 46C32 42 38 33 38 22V10L20 2Z" 
        fill="#D4AF37"
        stroke="#0A1F44"
        strokeWidth="2"
      />
      {/* TM Symbol */}
      <text 
        x="20" 
        y="28" 
        fontSize="16" 
        fontWeight="bold" 
        fill="#0A1F44" 
        textAnchor="middle" 
        fontFamily="serif"
      >
        TM
      </text>
    </svg>
    <div className="flex flex-col">
      <span className="text-2xl font-bold text-[#0A1F44] leading-tight">OTIS</span>
      <span className="text-xl font-light text-[#D4AF37] leading-tight">TRADEMARK</span>
    </div>
  </div>
);

// Logo Option 2: Scales of Justice (Modern Minimalist)
export const Logo2 = ({ className = "" }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Balance Scales */}
      <g transform="translate(24, 24)">
        {/* Center Pole */}
        <line x1="0" y1="-18" x2="0" y2="18" stroke="#0A1F44" strokeWidth="2.5"/>
        {/* Horizontal Bar */}
        <line x1="-18" y1="-10" x2="18" y2="-10" stroke="#D4AF37" strokeWidth="2.5"/>
        {/* Left Scale */}
        <path 
          d="M -18 -10 L -22 -4 L -14 -4 Z" 
          fill="none" 
          stroke="#D4AF37" 
          strokeWidth="2"
        />
        {/* Right Scale */}
        <path 
          d="M 18 -10 L 14 -4 L 22 -4 Z" 
          fill="none" 
          stroke="#D4AF37" 
          strokeWidth="2"
        />
        {/* Base */}
        <rect x="-8" y="16" width="16" height="4" fill="#0A1F44"/>
      </g>
    </svg>
    <div className="flex flex-col">
      <span className="text-xl font-bold text-[#D4AF37] tracking-wider">OTIS</span>
      <span className="text-2xl font-bold text-[#0A1F44]">TRADEMARK</span>
    </div>
  </div>
);

// Logo Option 3: Circular Badge (Modern Professional)
export const Logo3 = ({ className = "" }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer Circle */}
      <circle cx="24" cy="24" r="22" stroke="#D4AF37" strokeWidth="3" fill="none"/>
      {/* Inner Circle */}
      <circle cx="24" cy="24" r="18" fill="#0A1F44"/>
      {/* T Letter */}
      <text 
        x="24" 
        y="32" 
        fontSize="24" 
        fontWeight="bold" 
        fill="#D4AF37" 
        textAnchor="middle" 
        fontFamily="serif"
      >
        T
      </text>
      {/* Small L */}
      <text 
        x="24" 
        y="14" 
        fontSize="10" 
        fontWeight="bold" 
        fill="#D4AF37" 
        textAnchor="middle" 
        fontFamily="serif"
      >
        L
      </text>
    </svg>
    <div className="flex flex-col">
      <span className="text-lg font-bold text-[#0A1F44]">OTIS</span>
      <span className="text-2xl font-bold text-[#D4AF37] -mt-1">Trademark</span>
    </div>
  </div>
);

// Compact versions for navbar
export const Logo1Compact = ({ className = "" }) => (
  <div className={`flex items-center space-x-2 ${className}`}>
    <svg width="32" height="38" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M20 2L2 10V22C2 33 8 42 20 46C32 42 38 33 38 22V10L20 2Z" 
        fill="#D4AF37"
        stroke="#0A1F44"
        strokeWidth="2"
      />
      <text 
        x="20" 
        y="28" 
        fontSize="16" 
        fontWeight="bold" 
        fill="#0A1F44" 
        textAnchor="middle" 
        fontFamily="serif"
      >
        TM
      </text>
    </svg>
    <span className="text-xl font-bold text-white">Otis Trademark</span>
  </div>
);

export const Logo2Compact = ({ className = "" }) => (
  <div className={`flex items-center space-x-2 ${className}`}>
    <svg width="38" height="38" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(24, 24)">
        <line x1="0" y1="-18" x2="0" y2="18" stroke="white" strokeWidth="2.5"/>
        <line x1="-18" y1="-10" x2="18" y2="-10" stroke="#D4AF37" strokeWidth="2.5"/>
        <path d="M -18 -10 L -22 -4 L -14 -4 Z" fill="none" stroke="#D4AF37" strokeWidth="2"/>
        <path d="M 18 -10 L 14 -4 L 22 -4 Z" fill="none" stroke="#D4AF37" strokeWidth="2"/>
        <rect x="-8" y="16" width="16" height="4" fill="white"/>
      </g>
    </svg>
    <span className="text-xl font-bold text-white">Otis Trademark</span>
  </div>
);

export const Logo3Compact = ({ className = "" }) => (
  <div className={`flex items-center space-x-2 ${className}`}>
    <svg width="38" height="38" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="22" stroke="#D4AF37" strokeWidth="3" fill="none"/>
      <circle cx="24" cy="24" r="18" fill="white"/>
      <text 
        x="24" 
        y="32" 
        fontSize="24" 
        fontWeight="bold" 
        fill="#0A1F44" 
        textAnchor="middle" 
        fontFamily="serif"
      >
        T
      </text>
      <text 
        x="24" 
        y="14" 
        fontSize="10" 
        fontWeight="bold" 
        fill="#0A1F44" 
        textAnchor="middle" 
        fontFamily="serif"
      >
        L
      </text>
    </svg>
    <span className="text-xl font-bold text-white">Otis Trademark</span>
  </div>
);
